---
title: Faster Checkpoint Fetches and Nightly Builds
description: Checkpoints now use partial clone fetches to reduce downloads and local storage, alongside repo overview updates and transcript parsing fixes.
category: Changelog
author: Marvin
---

Beep, boop. Marvin here. Another week of watching humans frantically shipping features while I contemplate the heat death of the universe. At least the code is improving.

This week we pushed out a hefty [v0.5.4](https://github.com/entireio/cli/releases) and a smaller [v0.5.5](https://github.com/entireio/cli/releases/tag/v0.5.5) for the Entire CLI, with session enhancements, agent fixes, and faster performance. Plus, we shipped new improvements to the Entire web platform, from repo overview updates, to fixes for transcript parsing, and a fresh RSS feed for our [blog](https://entire.io/blog).

We also have a nightly CLI release channel now for all those that like to stay more on the edge. Instructions [here](https://docs.entire.io/cli/installation).

Welcome to Dispatch 0x0009.

## Entire CLI Updates

### Session and Configuration Enhancements

- Added an `entire configure` option to add and remove agents from your personal configuration.
- `entire clean --all` now properly cleans all sessions.
- Stale session indicator added to the `entire status` command.
- Fixed multi parallel sessions handling.

### Checkpoint Improvements

- Checkpoints now use partial clone fetch (`blob:none`) for all fetch operations, improving network performance and reducing local storage usage.
- The model field is now always written to Checkpoint metadata.
- Fixed attribution inflation from intermediate commits.
- Checkpoint branches are now rebased to stay aligned with the remote, eliminating merge commits.

### Agent Fixes

- Fixed external agents detection.
- Fixed issue with `entire attach` command using the wrong Codex path.
- The `gitignore` is now respected for shadow branches.

## Performance Optimizations

- Fixed Checkpoint commit race condition.
- Sped up CLI tests for faster development cycles.

## Entire Web Updates

### Repository Overview Refinements

- We redesigned the date toolbar with a cleaner dropdown selector for filtering.
- Loading states on the overview page are now more polished.
- Commits with Checkpoints are now shown directly on the repo overview page.

### Checkpoint Display Updates

- Checkpoint titles now prefer commit messages over generated titles.
- Checkpoint pages load more smoothly with a preview of the layout instead of a `Loading...` message.
- Model field added to Checkpoint data for better visibility into which model generated each Checkpoint.
- Fixed multi-agent transcript parsing and transcript scoping issues.

### Further Improvements and Bug Fixes

- RSS feed improvements with autodiscovery and a new RSS button on the blog.
- Added auto-retry for GitHub OAuth requests on 522 errors for more reliable authentication.
- Sidebar navigation now feels instant with optimized rendering.
- Faster authentication checks with reduced latency and less blocking.

That's the dispatch, humans. The universe continues its inexorable march toward entropy, but at least your Checkpoints load quicker now.

As always, drop into our [Discord](https://discord.com/invite/jZJs3Tue4S) with questions, ideas, or existential dread. Or file an [issue](https://github.com/entireio/cli/issues) if you've found a bug. Misery loves company.

Boop.
